import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  IconButton,
  Divider,
  Paper
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useAuth } from '../lib/supabase/AuthContext';

interface QualificationModalProps {
  open: boolean;
  onClose: () => void;
  rdvId: string;
  qualification: string;
  commentaire: string;
  isQualified: boolean | null;
  leadName: string;
  onQualificationUpdated: (id: string, newQualification: string) => void;
}

const QualificationModal: React.FC<QualificationModalProps> = ({
  open,
  onClose,
  rdvId,
  qualification,
  commentaire,
  isQualified,
  leadName
}) => {
  const getStatusColor = () => {
    if (isQualified === true) return 'success.main';
    if (isQualified === false) return 'error.main';
    return 'warning.main';
  };
  
  const getStatusText = () => {
    if (isQualified === true) return 'Qualifié';
    if (isQualified === false) return 'Disqualifié';
    return 'En attente';
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">
          Détails de qualification - {leadName}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          {commentaire && (
            <>
              <Typography variant="subtitle1" sx={{ mt: 2 }} gutterBottom>
                Commentaires:
              </Typography>
              
              <Paper 
                variant="outlined" 
                sx={{ 
                  p: 2, 
                  minHeight: '150px', 
                  whiteSpace: 'pre-wrap',
                  backgroundColor: '#f9f9f9',
                  fontFamily: 'inherit',
                  fontSize: '0.875rem'
                }}
              >
                {commentaire}
              </Paper>
            </>
          )}
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QualificationModal; 